import clsx from 'clsx';
import { motion } from 'motion/react';
import AnimatedPlayerLoading from '../components/Animated/Backgrounds/AnimatedPlayerLoadingBackground';
import LoadingDots from '../components/Animated/Icons/LoadingDots';
import OldLogoIcon from '@/components/Icons/OldLogoIcon';

type IntermidiateStepProps = {
  title?: string;
  subtitle?: string;
  showLoadingDots?: boolean;
};

export const IntermidiateStep = ({ title, subtitle, showLoadingDots }: IntermidiateStepProps) => {
  return (
    <>
      <AnimatedPlayerLoading />
      <div
        className={clsx(
          'flex flex-col w-full items-center justify-center w-full h-full container mx-auto max-w-3xl px-16'
        )}
      >
        <OldLogoIcon
          alt="Logo"
          className={clsx('mx-auto max-w-176 absolute inset-40 text-white')}
        />
        <div className="flex flex-col items-center justify-center">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {!!title && (
              <motion.h1
                initial={{ opacity: 0, y: -200 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -200 }}
                transition={{ type: 'spring', bounce: 0.3 }}
                className="font-extrabold text-center text-4xl text-[#1D1A34] mt-80"
              >
                {title}
              </motion.h1>
            )}
            {!!subtitle && (
              <motion.p
                initial={{ opacity: 0, y: -200 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -200 }}
                transition={{ type: 'spring', bounce: 0.3 }}
                className="mt-16 text-center text-[#1D1A34] text-2xl mx-14 font-bold mb-24"
              >
                {subtitle}
              </motion.p>
            )}
            {showLoadingDots && <LoadingDots />}
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default IntermidiateStep;
